import {
  getPage,
  searchByName,
  modifyObj,
  getAll,
  getDetail,
  deleteObj,
  addObj,
  getMyAll,
  getMyPage,
  getByGroupId,
  clientSearch,
  getBindAll,
  getClientPage,
  transfer,
  attentionAll,
  changePicture,
  getAllSubscribe,
  getClientBindVehicleInfosPage,
  getMyUserGroupAll,
  getDirectlyUnderBindAll,
  getDirectlyUnderBindPage,
  getGroupRecursiveAll,
  getMyUserGroupPage,
  analyzeCertificatePicture,
  analyzeVehicleLicensePicture,
  changeBusinessUser,
  uploadChangeBusinessUserFile,
  exportCompositeReport,
  bindPositioningDeviceInfos,
  unBindUserVehicleInfos,
  inquireOperation,
  unBindPositioningDeviceInfos,
  bindVehicleInfosToUser
} from '@/api/vehicleinfoserv'

export default {
  state: {
    state_VehicleInfo_GetPageResult: null,
    state_VehicleInfo_SearchByNameResult: null,
    state_VehicleInfo_ModifyObjResult: null,
    state_VehicleInfo_GetAllResult: null,
    state_VehicleInfo_GetDetailResult: null,
    state_VehicleInfo_DeleteObjResult: null,
    state_VehicleInfo_AddObjResult: null,
    state_VehicleInfo_GetMyAllResult: null,
    state_VehicleInfo_GetMyPageResult: null,
    state_VehicleInfo_GetByGroupIdResult: null,
    state_VehicleInfo_ClientSearchResult: null,
    state_VehicleInfo_GetBindAllResult: null,
    state_VehicleInfo_GetClientPageResult: null,
    state_VehicleInfo_TransferResult: null,
    state_VehicleInfo_AttentionAllResult: null,
    state_VehicleInfo_ChangePictureResult: null,
    state_VehicleInfo_GetAllSubscribeResult: null,
    state_VehicleInfo_GetClientBindVehicleInfosPageResult: null,
    state_VehicleInfo_GetMyUserGroupAllResult: null,
    state_VehicleInfo_GetDirectlyUnderBindAllResult: null,
    state_VehicleInfo_GetDirectlyUnderBindPageResult: null,
    state_VehicleInfo_GetGroupRecursiveAllResult: null,
    state_VehicleInfo_GetMyUserGroupPageResult: null,
    state_VehicleInfo_AnalyzeCertificatePictureResult: null,
    state_VehicleInfo_AnalyzeVehicleLicensePictureResult: null,
    state_VehicleInfo_ChangeBusinessUserResult: null,
    state_VehicleInfo_UploadChangeBusinessUserFileResult: null,
    state_VehicleInfo_ExportCompositeReportResult: null,
    state_VehicleInfo_BindPositioningDeviceInfosResult: null,
    state_VehicleInfo_UnBindUserVehicleInfosResult: null,
    state_VehicleInfo_InquireOperationResult: null,
    state_VehicleInfo_UnBindPositioningDeviceInfosResult: null,
    state_VehicleInfo_BindVehicleInfosToUserResult: null
  },
  mutations: {
    SET_VEHICLEINFO_GETPAGE_RESULT: (state, rst) => {
      state.state_VehicleInfo_GetPageResult = rst
    },
    SET_VEHICLEINFO_SEARCHBYNAME_RESULT: (state, rst) => {
      state.state_VehicleInfo_SearchByNameResult = rst
    },
    SET_VEHICLEINFO_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_VehicleInfo_ModifyObjResult = rst
    },
    SET_VEHICLEINFO_GETALL_RESULT: (state, rst) => {
      state.state_VehicleInfo_GetAllResult = rst
    },
    SET_VEHICLEINFO_GETDETAIL_RESULT: (state, rst) => {
      state.state_VehicleInfo_GetDetailResult = rst
    },
    SET_VEHICLEINFO_DELETEOBJ_RESULT: (state, rst) => {
      state.state_VehicleInfo_DeleteObjResult = rst
    },
    SET_VEHICLEINFO_ADDOBJ_RESULT: (state, rst) => {
      state.state_VehicleInfo_AddObjResult = rst
    },
    SET_VEHICLEINFO_GETMYALL_RESULT: (state, rst) => {
      state.state_VehicleInfo_GetMyAllResult = rst
    },
    SET_VEHICLEINFO_GETMYPAGE_RESULT: (state, rst) => {
      state.state_VehicleInfo_GetMyPageResult = rst
    },
    SET_VEHICLEINFO_GETBYGROUPID_RESULT: (state, rst) => {
      state.state_VehicleInfo_GetByGroupIdResult = rst
    },
    SET_VEHICLEINFO_CLIENTSEARCH_RESULT: (state, rst) => {
      state.state_VehicleInfo_ClientSearchResult = rst
    },
    SET_VEHICLEINFO_GETBINDALL_RESULT: (state, rst) => {
      state.state_VehicleInfo_GetBindAllResult = rst
    },
    SET_VEHICLEINFO_GETCLIENTPAGE_RESULT: (state, rst) => {
      state.state_VehicleInfo_GetClientPageResult = rst
    },
    SET_VEHICLEINFO_TRANSFER_RESULT: (state, rst) => {
      state.state_VehicleInfo_TransferResult = rst
    },
    SET_VEHICLEINFO_ATTENTIONALL_RESULT: (state, rst) => {
      state.state_VehicleInfo_AttentionAllResult = rst
    },
    SET_VEHICLEINFO_CHANGEPICTURE_RESULT: (state, rst) => {
      state.state_VehicleInfo_ChangePictureResult = rst
    },
    SET_VEHICLEINFO_GETALLSUBSCRIBE_RESULT: (state, rst) => {
      state.state_VehicleInfo_GetAllSubscribeResult = rst
    },
    SET_VEHICLEINFO_GETCLIENTBINDVEHICLEINFOSPAGE_RESULT: (state, rst) => {
      state.state_VehicleInfo_GetClientBindVehicleInfosPageResult = rst
    },
    SET_VEHICLEINFO_GETMYUSERGROUPALL_RESULT: (state, rst) => {
      state.state_VehicleInfo_GetMyUserGroupAllResult = rst
    },
    SET_VEHICLEINFO_GETDIRECTLYUNDERBINDALL_RESULT: (state, rst) => {
      state.state_VehicleInfo_GetDirectlyUnderBindAllResult = rst
    },
    SET_VEHICLEINFO_GETDIRECTLYUNDERBINDPAGE_RESULT: (state, rst) => {
      state.state_VehicleInfo_GetDirectlyUnderBindPageResult = rst
    },
    SET_VEHICLEINFO_GETGROUPRECURSIVEALL_RESULT: (state, rst) => {
      state.state_VehicleInfo_GetGroupRecursiveAllResult = rst
    },
    SET_VEHICLEINFO_GETMYUSERGROUPPAGE_RESULT: (state, rst) => {
      state.state_VehicleInfo_GetMyUserGroupPageResult = rst
    },
    SET_VEHICLEINFO_ANALYZECERTIFICATEPICTURE_RESULT: (state, rst) => {
      state.state_VehicleInfo_AnalyzeCertificatePictureResult = rst
    },
    SET_VEHICLEINFO_ANALYZEVEHICLELICENSEPICTURE_RESULT: (state, rst) => {
      state.state_VehicleInfo_AnalyzeVehicleLicensePictureResult = rst
    },
    SET_VEHICLEINFO_CHANGEBUSINESSUSER_RESULT: (state, rst) => {
      state.state_VehicleInfo_ChangeBusinessUserResult = rst
    },
    SET_VEHICLEINFO_UPLOADCHANGEBUSINESSUSERFILE_RESULT: (state, rst) => {
      state.state_VehicleInfo_UploadChangeBusinessUserFileResult = rst
    },
    SET_VEHICLEINFO_EXPORTCOMPOSITEREPORT_RESULT: (state, rst) => {
      state.state_VehicleInfo_ExportCompositeReportResult = rst
    },
    SET_VEHICLEINFO_BINDPOSITIONINGDEVICEINFOS_RESULT: (state, rst) => {
      state.state_VehicleInfo_BindPositioningDeviceInfosResult = rst
    },
    SET_VEHICLEINFO_UNBINDUSERVEHICLEINFOS_RESULT: (state, rst) => {
      state.state_VehicleInfo_UnBindUserVehicleInfosResult = rst
    },
    SET_VEHICLEINFO_INQUIREOPERATION_RESULT: (state, rst) => {
      state.state_VehicleInfo_InquireOperationResult = rst
    },
    SET_VEHICLEINFO_UNBINDPOSITIONINGDEVICEINFOS_RESULT: (state, rst) => {
      state.state_VehicleInfo_UnBindPositioningDeviceInfosResult = rst
    },
    SET_VEHICLEINFO_BINDVEHICLEINFOSTOUSER_RESULT: (state, rst) => {
      state.state_VehicleInfo_BindVehicleInfosToUserResult = rst
    }
  },
  actions: {
    VehicleInfoServ_GetPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFO_GETPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEINFO_GETPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleInfoServ_SearchByName ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        searchByName(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFO_SEARCHBYNAME_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEINFO_SEARCHBYNAME_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleInfoServ_ModifyObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFO_MODIFYOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEINFO_MODIFYOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleInfoServ_GetAll ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFO_GETALL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEINFO_GETALL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleInfoServ_GetDetail ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFO_GETDETAIL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEINFO_GETDETAIL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleInfoServ_DeleteObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFO_DELETEOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEINFO_DELETEOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleInfoServ_AddObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        addObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFO_ADDOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEINFO_ADDOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleInfoServ_GetMyAll ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getMyAll(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFO_GETMYALL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEINFO_GETMYALL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleInfoServ_GetMyPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getMyPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFO_GETMYPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEINFO_GETMYPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleInfoServ_GetByGroupId ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getByGroupId(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFO_GETBYGROUPID_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEINFO_GETBYGROUPID_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleInfoServ_ClientSearch ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        clientSearch(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFO_CLIENTSEARCH_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEINFO_CLIENTSEARCH_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleInfoServ_GetBindAll ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getBindAll(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFO_GETBINDALL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEINFO_GETBINDALL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleInfoServ_GetClientPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getClientPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFO_GETCLIENTPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEINFO_GETCLIENTPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleInfoServ_Transfer ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        transfer(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFO_TRANSFER_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEINFO_TRANSFER_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleInfoServ_AttentionAll ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        attentionAll(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFO_ATTENTIONALL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEINFO_ATTENTIONALL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleInfoServ_ChangePicture ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        changePicture(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFO_CHANGEPICTURE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEINFO_CHANGEPICTURE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleInfoServ_GetAllSubscribe ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getAllSubscribe(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFO_GETALLSUBSCRIBE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEINFO_GETALLSUBSCRIBE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleInfoServ_GetClientBindVehicleInfosPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getClientBindVehicleInfosPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFO_GETCLIENTBINDVEHICLEINFOSPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEINFO_GETCLIENTBINDVEHICLEINFOSPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleInfoServ_GetMyUserGroupAll ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getMyUserGroupAll(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFO_GETMYUSERGROUPALL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEINFO_GETMYUSERGROUPALL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleInfoServ_GetDirectlyUnderBindAll ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getDirectlyUnderBindAll(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFO_GETDIRECTLYUNDERBINDALL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEINFO_GETDIRECTLYUNDERBINDALL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleInfoServ_GetDirectlyUnderBindPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getDirectlyUnderBindPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFO_GETDIRECTLYUNDERBINDPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEINFO_GETDIRECTLYUNDERBINDPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleInfoServ_GetGroupRecursiveAll ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getGroupRecursiveAll(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFO_GETGROUPRECURSIVEALL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEINFO_GETGROUPRECURSIVEALL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleInfoServ_GetMyUserGroupPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getMyUserGroupPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFO_GETMYUSERGROUPPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEINFO_GETMYUSERGROUPPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleInfoServ_AnalyzeCertificatePicture ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        analyzeCertificatePicture(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFO_ANALYZECERTIFICATEPICTURE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEINFO_ANALYZECERTIFICATEPICTURE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleInfoServ_AnalyzeVehicleLicensePicture ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        analyzeVehicleLicensePicture(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFO_ANALYZEVEHICLELICENSEPICTURE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEINFO_ANALYZEVEHICLELICENSEPICTURE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleInfoServ_ChangeBusinessUser ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        changeBusinessUser(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFO_CHANGEBUSINESSUSER_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEINFO_CHANGEBUSINESSUSER_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleInfoServ_UploadChangeBusinessUserFile ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        uploadChangeBusinessUserFile(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFO_UPLOADCHANGEBUSINESSUSERFILE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEINFO_UPLOADCHANGEBUSINESSUSERFILE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleInfoServ_ExportCompositeReport ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        exportCompositeReport(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFO_EXPORTCOMPOSITEREPORT_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEINFO_EXPORTCOMPOSITEREPORT_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleInfoServ_BindPositioningDeviceInfos ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        bindPositioningDeviceInfos(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFO_BINDPOSITIONINGDEVICEINFOS_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEINFO_BINDPOSITIONINGDEVICEINFOS_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleInfoServ_UnBindUserVehicleInfos ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        unBindUserVehicleInfos(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFO_UNBINDUSERVEHICLEINFOS_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEINFO_UNBINDUSERVEHICLEINFOS_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleInfoServ_InquireOperation ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        inquireOperation(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFO_INQUIREOPERATION_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEINFO_INQUIREOPERATION_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleInfoServ_UnBindPositioningDeviceInfos ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        unBindPositioningDeviceInfos(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFO_UNBINDPOSITIONINGDEVICEINFOS_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEINFO_UNBINDPOSITIONINGDEVICEINFOS_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleInfoServ_BindVehicleInfosToUser ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        bindVehicleInfosToUser(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFO_BINDVEHICLEINFOSTOUSER_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEINFO_BINDVEHICLEINFOSTOUSER_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    }
  },
  getters: {
    get_VehicleInfo_GetPageResult: state => {
      return state.state_VehicleInfo_GetPageResult
    },
    get_VehicleInfo_SearchByNameResult: state => {
      return state.state_VehicleInfo_SearchByNameResult
    },
    get_VehicleInfo_ModifyObjResult: state => {
      return state.state_VehicleInfo_ModifyObjResult
    },
    get_VehicleInfo_GetAllResult: state => {
      return state.state_VehicleInfo_GetAllResult
    },
    get_VehicleInfo_GetDetailResult: state => {
      return state.state_VehicleInfo_GetDetailResult
    },
    get_VehicleInfo_DeleteObjResult: state => {
      return state.state_VehicleInfo_DeleteObjResult
    },
    get_VehicleInfo_AddObjResult: state => {
      return state.state_VehicleInfo_AddObjResult
    },
    get_VehicleInfo_GetMyAllResult: state => {
      return state.state_VehicleInfo_GetMyAllResult
    },
    get_VehicleInfo_GetMyPageResult: state => {
      return state.state_VehicleInfo_GetMyPageResult
    },
    get_VehicleInfo_GetByGroupIdResult: state => {
      return state.state_VehicleInfo_GetByGroupIdResult
    },
    get_VehicleInfo_ClientSearchResult: state => {
      return state.state_VehicleInfo_ClientSearchResult
    },
    get_VehicleInfo_GetBindAllResult: state => {
      return state.state_VehicleInfo_GetBindAllResult
    },
    get_VehicleInfo_GetClientPageResult: state => {
      return state.state_VehicleInfo_GetClientPageResult
    },
    get_VehicleInfo_TransferResult: state => {
      return state.state_VehicleInfo_TransferResult
    },
    get_VehicleInfo_AttentionAllResult: state => {
      return state.state_VehicleInfo_AttentionAllResult
    },
    get_VehicleInfo_ChangePictureResult: state => {
      return state.state_VehicleInfo_ChangePictureResult
    },
    get_VehicleInfo_GetAllSubscribeResult: state => {
      return state.state_VehicleInfo_GetAllSubscribeResult
    },
    get_VehicleInfo_GetClientBindVehicleInfosPageResult: state => {
      return state.state_VehicleInfo_GetClientBindVehicleInfosPageResult
    },
    get_VehicleInfo_GetMyUserGroupAllResult: state => {
      return state.state_VehicleInfo_GetMyUserGroupAllResult
    },
    get_VehicleInfo_GetDirectlyUnderBindAllResult: state => {
      return state.state_VehicleInfo_GetDirectlyUnderBindAllResult
    },
    get_VehicleInfo_GetDirectlyUnderBindPageResult: state => {
      return state.state_VehicleInfo_GetDirectlyUnderBindPageResult
    },
    get_VehicleInfo_GetGroupRecursiveAllResult: state => {
      return state.state_VehicleInfo_GetGroupRecursiveAllResult
    },
    get_VehicleInfo_GetMyUserGroupPageResult: state => {
      return state.state_VehicleInfo_GetMyUserGroupPageResult
    },
    get_VehicleInfo_AnalyzeCertificatePictureResult: state => {
      return state.state_VehicleInfo_AnalyzeCertificatePictureResult
    },
    get_VehicleInfo_AnalyzeVehicleLicensePictureResult: state => {
      return state.state_VehicleInfo_AnalyzeVehicleLicensePictureResult
    },
    get_VehicleInfo_ChangeBusinessUserResult: state => {
      return state.state_VehicleInfo_ChangeBusinessUserResult
    },
    get_VehicleInfo_UploadChangeBusinessUserFileResult: state => {
      return state.state_VehicleInfo_UploadChangeBusinessUserFileResult
    },
    get_VehicleInfo_ExportCompositeReportResult: state => {
      return state.state_VehicleInfo_ExportCompositeReportResult
    },
    get_VehicleInfo_BindPositioningDeviceInfosResult: state => {
      return state.state_VehicleInfo_BindPositioningDeviceInfosResult
    },
    get_VehicleInfo_UnBindUserVehicleInfosResult: state => {
      return state.state_VehicleInfo_UnBindUserVehicleInfosResult
    },
    get_VehicleInfo_InquireOperationResult: state => {
      return state.state_VehicleInfo_InquireOperationResult
    },
    get_VehicleInfo_UnBindPositioningDeviceInfosResult: state => {
      return state.state_VehicleInfo_UnBindPositioningDeviceInfosResult
    },
    get_VehicleInfo_BindVehicleInfosToUserResult: state => {
      return state.state_VehicleInfo_BindVehicleInfosToUserResult
    }
  }
}
